import { BorrowerTab } from './borrower-tab';

export class GlobalBorrowerTabsPatch {
  static readonly type = '[GlobalBorrowerTabs] GlobalBorrowerTabsPatch';
  constructor(
    public tabs: BorrowerTab[]
  ) {}
}

export class GlobalBorrowerTabUpdate {
  static readonly type = '[GlobalBorrowerTabs] GlobalBorrowerTabUpdate';
  constructor(public tab: BorrowerTab) {}
}

export class GlobalBorrowerTabsInactive {
  static readonly type = '[GlobalBorrowerTabs] GlobalBorrowerTabsInactive';
  constructor() {}
}

export class GlobalBorrowerTabClose {
  static readonly type = '[GlobalBorrowerTabs] GlobalBorrowerTabClose';
  constructor(public tabId: number) {}
}

export class GlobalBorrowerTabsCloseAll {
  static readonly type = '[GlobalBorrowerTabs] GlobalBorrowerTabsCloseAll';
  constructor() {}
}
